import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'libs/shared/web/auth/auth.service';
import { SignInService } from 'libs/shared/web/auth/sign-in/sign.in.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptorService {
  constructor(private injector: Injector, private router: Router, private authService: AuthService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authService = this.injector.get(SignInService);

    if (!window.navigator.onLine) {
      return throwError(() => new HttpErrorResponse({ error: 'Internet is required.' }));
    } else {
        const headers: { [name: string]: string } = {
        Authorization: `Bearer ${authService.getToken()}`
      };

      const workspaceId = authService.getWorkspaceId();
      if (workspaceId) {
        headers['workspaceId'] = workspaceId;
      }

      const tokenizedReq = req.clone({
      setHeaders: headers
      });

      return next.handle(tokenizedReq).pipe(
        catchError((error: HttpErrorResponse) => {
          const isTokenExpired =
          (error.status === 401 || error.status === 500) &&
          (
            error?.error?.error?.errorList === 'UNAUTHORIZED TOKEN'
          );

    if (isTokenExpired) {
      this.authService.logOut();
      this.router.navigate(['/signin']).catch(() => {});
    }
          return throwError(() => error);
        })
      );
    }
  }
}
